import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24a4e99e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "products-section container" }
const _hoisted_2 = { ref: "offersScrollTop" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"64px"} }, null, -1 /* HOISTED */))
const _hoisted_4 = { class: "products" }
const _hoisted_5 = { ref: "offersBottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, null, 512 /* NEED_PATCH */),
    _createVNode($setup["IconTitle"], {
      icon: $setup.Icons.imported.faTag,
      title: "Ofertas"
    }, null, 8 /* PROPS */, ["icon"]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.products, (product, index) => {
        return _withDirectives((_openBlock(), _createBlock($setup["ProductCard"], {
          key: index,
          product: product,
          "amount-in-cart": $setup.cartStore.getCartProduct(product.id)?.quantity,
          "stock-quantity": product.getAvailableStock(),
          onSetAmount: (amount) => $setup.cartStore.setAmount(product, amount),
          onRemoveFromCart: ($event: any) => ($setup.cartStore.removeFromCart(product)),
          onAddToCart: (amount) => $setup.cartStore.addToCart(product, amount)
        }, null, 8 /* PROPS */, ["product", "amount-in-cart", "stock-quantity", "onSetAmount", "onRemoveFromCart", "onAddToCart"])), [
          [_vShow, $props.isLoaded]
        ])
      }), 128 /* KEYED_FRAGMENT */)),
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (index) => {
        return _withDirectives(_createVNode($setup["ShimmerGFX"], {
          key: index,
          width: 310,
          height: 507
        }), [
          [_vShow, !$props.isLoaded]
        ])
      }), 64 /* STABLE_FRAGMENT */))
    ]),
    _createElementVNode("div", _hoisted_5, null, 512 /* NEED_PATCH */)
  ]))
}